import { Dispatch } from 'redux';
import { showFeedback } from '../../../feedback/feedbackReducer';
import { screeningClearanceRuleContentApi } from '../../../apis';
import { InternalApiScreeningClearanceRuleContent } from '../../../api-internal';
import { ScreeningClearanceRuleContentModalFormValues } from './ScreeningClearanceRuleContentModal';

export const saveScreeningClearanceRuleContent =
  ({ id, ruleHandle, status, content, note }: ScreeningClearanceRuleContentModalFormValues) =>
  async (dispatch: Dispatch) => {
    const apiRuleContent = {
      details: 'asd',
      content: content || '',
      note: note || '',
      status: status.value,
    } as InternalApiScreeningClearanceRuleContent;
    if (id !== undefined) {
      await screeningClearanceRuleContentApi.updateRuleContent({
        handle: ruleHandle,
        id,
        internalApiScreeningClearanceRuleContent: apiRuleContent,
      });
      dispatch(
        showFeedback({
          message: `Screening clearance rule content updated!`,
          success: true,
        })
      );
    } else {
      await screeningClearanceRuleContentApi.addRuleContent({
        handle: ruleHandle,
        internalApiScreeningClearanceRuleContent: apiRuleContent,
      });
      dispatch(
        showFeedback({
          message: `Screening clearance rule content added!`,
          success: true,
        })
      );
    }
  };
